// extracted by mini-css-extract-plugin
export var header = "_wo-1";
export var maskBottom = "_wo-6";
export var maskMiddle = "_wo-7";
export var maskTop = "_wo-5";
export var root = "_wo-0";
export var scrollDownButton = "_wo-3";
export var scrollDownButtonHidden = "_wo-4";
export var viewport = "_wo-2";